import { render, staticRenderFns } from "./AdvancedDynamicToggleCollapse.vue?vue&type=template&id=04514bc0&scoped=true"
import script from "./AdvancedDynamicToggleCollapse.vue?vue&type=script&lang=js"
export * from "./AdvancedDynamicToggleCollapse.vue?vue&type=script&lang=js"
import style0 from "./AdvancedDynamicToggleCollapse.vue?vue&type=style&index=0&id=04514bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04514bc0",
  null
  
)

export default component.exports